import { useState } from 'react';

import { downloadCustomPacingTemplate } from '../../../../../../apis/campaignGraphqlManager/customPacing';
import type { DownloadFileError } from '../../../../../../apis/util/downloadFileError';
import { openErrorToastAlert } from '../../../../../../common/ToastAlert/toastAlert';

export type UseDownloadCustomPacingTemplate = {
  loading: boolean;
  handleDownload: () => Promise<void>;
};

export const useDownloadCustomPacingTemplate = (): UseDownloadCustomPacingTemplate => {
  const [loading, setLoading] = useState<boolean>(false);

  const handleDownload = async (): Promise<void> => {
    setLoading(true);

    try {
      await downloadCustomPacingTemplate();
    } catch (e) {
      const error: DownloadFileError = e;

      openErrorToastAlert(error.name, error.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    handleDownload,
  };
};
